import { createContext, ReactNode, useContext } from 'react'

const context = createContext(true)
const useIsReservationFlow = () => useContext(context)
const IsReservationFlowProvider = ({ children }: { children: ReactNode }) => <context.Provider value={true}>{children}</context.Provider>

export { IsReservationFlowProvider, useIsReservationFlow }
